/**
 * JavaScript で翻訳を行うための関数
 *
 * 1. Laracasts\Utilities\JavaScript\JavaScriptFacade::put() で、渡したい翻訳テキストを JavaScript の translatedText もしくは commonTranslatedTextに渡す
 *    * ページ固有の翻訳テキストを渡す場合
 *     (例:
 *      // app/Http/Controllers/○○.php
 *
 *      use Laracasts\Utilities\JavaScript\JavaScriptFacade;
 *
 *      ...
 *
 *      JavaScriptFacade::put([
 *          'translatedText' => __('pages/top'), // resources/lang/ja/pages/top.php の内容が渡される
 *      ])
 *
 *      ...
 *
 *    )
 *    * アプリケーション全体で共有する翻訳テキストを渡す場合
 *      resources/lang/ja/common.php javascriptフィールドの内容がcommonTranslatedTextとして渡される
 *
 * 2. 翻訳関数 __() を import する
 * 3. 翻訳関数 __() に渡したいキーを渡す。キーはドット区切りで JavaScript に渡された配列の階層をたどって取得することができる
 * 4. 単数形／複数形で翻訳が変わる場合は、第２引数に個数をセットする
 *    * 単数形／複数形の翻訳が定義されている場合は、翻訳テキストは"|"で分割されている
 *    * Laravelの翻訳処理を参照して実装[https://readouble.com/laravel/8.x/ja/localization.html]
 *
 * @param {string} key 翻訳関数に渡されたキー
 * @param {int|null} count 単数形／複数形を識別する
 * @returns {string} 対象のテキスト
 */
export function __ (key, count=null) {
  const allTranslatedText = {
    ... translatedText,
    ... commonTranslatedText
  }

  return getKeys(key).reduce((obj, key) => {
    let text = obj[key]

    // 個数の指定がある、かつ単数／複数の翻訳が定義されている場合
    if (count !== null && /.+\|.+/.test(obj[key])) {
      // 翻訳文字を"|"で分割する（0番目が単数系の翻訳テキスト、1番目が複数形の翻訳テキストとなる）
      const texts = obj[key].split("|")

      // count（個数）に応じた翻訳テキストを取得
      text = count > 1 ? texts[1] : texts[0]
    }

    return text;
  }, allTranslatedText);
}

/**
 * 翻訳関数に渡されたキーをドット区切りで分割して配列にする
 *
 * @param {string} key 翻訳関数に渡されたキー
 * @returns {string[]} ドット区切りで分割されたキーの配列
 */
function getKeys (key) {
  return key.indexOf('.') === -1
    ? [key]
    : key.split('.');
}

